
const StationChangeSignType = Object.freeze({
  S0D1: {
    code: 'S0D1'
  },
  S1D0: {
    code: 'S1D0'
  },
  S0D0: {
    code: 'S0D0'
  },
  S1D1: {
    code: 'S1D1'
  }

});

export default StationChangeSignType;
